// extracted by mini-css-extract-plugin
module.exports = {"highlighter":"FieldHighlighter_highlighter__2SsLX","wrapper":"FieldHighlighter_wrapper__324Pm"};